<template>
  <p class="price">
    <template v-if="isOnSale">
      <span class="original-price">{{ originalPrice }}</span>
      <span class="sale-price">{{ price }}</span>
    </template>
    <template v-else>
      {{ price }}
      <span v-if="showSalePreview" class="sale-price">{{
        salePreviewPrice
      }}</span>
    </template>
  </p>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductCardPrice",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    showSalePreview() {
      return this.isLoggedIn && this.salePreviewPrice;
    },
    salePreviewPrice() {
      return this.product.salePreviewPrice?.value;
    },
    price() {
      const price = this.product.priceRange?.minVariantPrice;
      return this.$filters.toCurrency(price.amount, price.currencyCode, 0);
    },
    originalPrice() {
      const price = this.product.compareAtPriceRange?.minVariantPrice;
      return this.$filters.toCurrency(price.amount, price.currencyCode, 0);
    },
    isOnSale() {
      return (
        parseFloat(this.product.compareAtPriceRange?.minVariantPrice?.amount) >
        parseFloat(this.product.priceRange?.minVariantPrice.amount)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.price {
  @include utility-label(14px);
  margin-top: 4px;

  .original-price {
    text-decoration: line-through;
    margin-right: 4px;
  }
  .sale-price {
    color: #d0021b;
    display: block;
  }
}
</style>
